import { Box, BoxProps, ColorOptions, convertHexToRGBA, IconButton, Spacer, Text, TextProps } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { DateRangeSelector } from '../../comps/Filters/DateRangeSelector'
import { useStores } from '../../data/store'
import { Colors } from '../../util/util'

const regex = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/

export const FiltersView = ({ applyFilters, clearFilters, cancel }: any) => {
  const { resetFilters, filter, updateSelectedFilterDateInfo } = useStores((root) => ({
    filter: root.billPayments.filter,
    updateSelectedFilterDateInfo: root.billPayments.updateSelectedFilterDateInfo,
    resetFilters: root.billPayments.resetFilters,
  }))
  const handleCancel = (): void => {
    cancel()
  }

  const handleApply = (): void => {
    applyFilters()
  }

  const handleClearAll = () => {
    resetFilters()
    clearFilters()
  }

  const invalidDate = () => {
    if (filter.selectedDateInfo?.dateLabel !== 'Custom Range') {
      return false
    } else if (
      (!filter.selectedDateInfo?.fromDate && !filter.selectedDateInfo?.toDate) ||
      (filter.selectedDateInfo?.dateLabel === 'Custom Range' &&
        !filter.selectedDateInfo?.fromDate &&
        !filter.selectedDateInfo?.toDate)
    ) {
      return true
    } else if (
      (filter.selectedDateInfo?.dateLabel === 'Custom Range' && !isEmpty(filter.selectedDateInfo?.fromDate),
        !isEmpty(filter.selectedDateInfo?.fromDate),
        !!regex?.test(filter.selectedDateInfo?.fromDate),
        !!regex?.test(filter.selectedDateInfo?.fromDate))
    ) {
      return false
    }
  }

  const disableBtn = invalidDate()

  return (
    <Box {...styles.container}>
      <Box {...styles.closeBox} flexDirection={'row'}>
        <Text textAlign="left" fontSize={24} fontFamily={'JioType-Black'} lineHeight={32} letterSpacing={-0.12}>
          {'Filters'}
        </Text>
        <IconButton size={24} id="CLOSE" testID="close-filter" onPress={handleCancel} color={'BLACK'} />
      </Box>
      <Box flexDirection={'row'}>
        <Box f={0.42} bg={convertHexToRGBA(Colors.PRIMARY, 4) as ColorOptions}>
          <Box {...sectionStyles.sectionBox}>
            <Text {...sectionStyles.sectionText}>{'By Date'}</Text>
          </Box>
        </Box>
        <Box f={0.58} h={320}>
          <DateRangeSelector
            onDateRangeChange={updateSelectedFilterDateInfo}
            selectedDateInfo={filter.selectedDateInfo}
            selectedFilteredData={filter}
          />
        </Box>
      </Box>
      <Box {...styles.buttonCon}>
        <Box
          onPress={handleClearAll}
          testID="clear-all-filter"
          width={148}
          align={'center'}
          justify={'center'}
          pv={16}
          underlayColor={convertHexToRGBA(Colors.PRIMARY, 50) as ColorOptions}
          borderRadius={100}
          borderWidth={1}
          disabled={disableBtn}
          opacity={disableBtn ? 0.5 : 1}
          borderColor={'PRIMARY'}>
          <Text
            title={'Clear All'}
            fontFamily={'JioType-Medium'}
            fontSize={16}
            letterSpacing={-0.08}
            color={'PRIMARY'}
          />
        </Box>
        <Spacer direction={'horizontal'} size={16} />
        <Box
          disabled={disableBtn}
          testID="apply-filter"
          onPress={handleApply}
          width={148}
          pv={16}
          align={'center'}
          justify={'center'}
          underlayColor={convertHexToRGBA(Colors.PRIMARY, 50) as ColorOptions}
          borderRadius={100}
          opacity={disableBtn ? 0.5 : 1}
          bg={'PRIMARY'}>
          <Text title={'Apply'} fontFamily={'JioType-Medium'} fontSize={16} letterSpacing={-0.08} color={'WHITE'} />
        </Box>
      </Box>
    </Box>
  )
}

const sectionStyles = {
  sectionBox: {
    justify: 'center',
    paddingLeft: 24,
    pv: 16,
    underlayColor: 'LIGHTEST_GREY',
    backgroundColor: convertHexToRGBA(Colors.PRIMARY, 8) as ColorOptions,
    borderRightWidth: 2,
    borderRightColor: 'BLACK',
  } as BoxProps,
  sectionText: {
    color: Colors.PRIMARY,
    fontFamily: 'JioType-Bold',
    fontSize: 14,
    lineHeight: 20,
    letterSpacing: -0.07,
  } as TextProps,
}

export const styles = {
  container: {
    borderTopLeftRadius: 32,
    borderTopRightRadius: 32,
    backgroundColor: 'WHITE',
  } as BoxProps,
  closeBox: {
    underlayColor: 'LIGHTEST_GREY',
    flexDirection: 'row',
    justify: 'space-between',
    align: 'center',
    borderBottomWidth: 1,
    borderBottomColor: 'DISABLED_GREY',
    p: 24,
  } as BoxProps,
  filterItemContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingHorizontal: 16,
    paddingVertical: 8,
    backgroundColor: 'GREYISH_WHITE',
  } as BoxProps,
  filterItem: {
    flexDirection: 'row',
    alignItems: 'center',
    pv: 16,
    ph: 24,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  inputContainer: {
    width: '100%',
    paddingHorizontal: 24,
    pv: 16,
  } as BoxProps,
  buttonCon: {
    justifyContent: 'space-around',
    position: 'relative',
    p: 24,
    borderTopWidth: 1,
    borderTopColor: 'DISABLED_GREY',
    flexDirection: 'row',
  } as BoxProps,
  line: {
    borderBottomWidth: 1,
    width: '100%',
    opacity: 0.1,
    marginTop: '10%',
  } as BoxProps,
}
